/**
 * Resource ids for the no-PII notice. The header and the ORIGINAL body were
 * approved as-is by the Workplace Trust privacy review (HRPRP-61509 —
 * https://issues.amazon.com/issues/HRPRP-61509). The current body is a shorter
 * rewording of that approved text — same PII examples, broadened from "the
 * free-form fields" to "any field" — and has NOT yet been re-confirmed by the
 * privacy reviewers; re-confirmation is tracked on HRPRP-61509. Do not reword
 * further without that sign-off. The tests pin the resolved copy verbatim, so no edit travels
 * silently.
 */
export const NO_PII_NOTICE_HEADER_ID = 'no-pii-notice-header';

export const NO_PII_NOTICE_BODY_ID = 'no-pii-notice-body';
